
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-area",
      function () {
        return require("private-next-pages/private-area/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-area"])
      });
    }
  